import { isEqual } from 'lodash-es';

/**
 * Represents the shape of the filter pane form data used by
 * Price Targets and Price/Volume Movers pages.
 */
export interface FilterFormData {
  mkCapLarge: boolean;
  mkCapMedium: boolean;
  mkCapSmall: boolean;
  mkCapMicro: boolean;
  mkCapLow: string;
  mkCapHigh: string;
  positionType: Array<string>;
  following: boolean;
  domainIds: Array<number>;
  portfolioIds: Array<number>;
}

/** Default (empty) filter state — no filters applied. */
export const DEFAULT_FILTER_FORM_DATA: FilterFormData = {
  mkCapLarge: false,
  mkCapMedium: false,
  mkCapSmall: false,
  mkCapMicro: false,
  mkCapLow: '',
  mkCapHigh: '',
  positionType: [],
  following: false,
  domainIds: [],
  portfolioIds: [],
};

/** Returns a fresh copy of the default filter form data with independent array references. */
export function createDefaultFilterFormData(): FilterFormData {
  return {
    ...DEFAULT_FILTER_FORM_DATA,
    positionType: [],
    domainIds: [],
    portfolioIds: [],
  };
}

/** Checks whether the given filter data represents the default (empty) state. */
export function isFilterEmpty(data: FilterFormData): boolean {
  if (!data || Object.keys(data).length === 0) {
    return true;
  }
  return isEqual(data, createDefaultFilterFormData());
}
